import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import getDisplayName from '_/utils/getDisplayName'
import { Map } from 'immutable'

/**
 * Mark duplicate modal
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MarkDuplicateModal extends React.Component {
  static propTypes = {
    show: React.PropTypes.bool,
    property: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired,
    onHide: React.PropTypes.func.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      masterRecord: Map(),
      link: createLinkToImmutable(this, 'masterRecord')
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      masterRecord: Map(),
      link: createLinkToImmutable(this, 'masterRecord')
    }
  }

  handleOptions (data) {
    return data.map(r => {
      return { value: r.get('id'), label: `${getDisplayName('property', r)} - ${r.get('pid')}` }
    }).toJS()
  }

  async markDuplicate () {
    const { property, onChange } = this.props
    const { masterRecord } = this.state
    const { store, notify } = this.context
    const id = property.get('id')

    try {
      const updatedProperty = await store.post(`/properties/${id}/markDuplicate`, masterRecord)
      onChange(updatedProperty)
    } catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  render () {
    const { show, onHide } = this.props
    const { link } = this.state

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <h3 className="modal-title">Mark property as duplicate</h3>
        </Modal.Header>

        <Modal.Body>
          <Input
            type="select-ajax"
            handleOptions={::this.handleOptions}
            placeholder="Select master record..."
            name="records"
            valueLink={link('id')}
            url="/records?isPrivate=false" />

          <Button
            bsStyle="warning"
            onClick={::this.markDuplicate}>
            Mark duplicate
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default MarkDuplicateModal



// WEBPACK FOOTER //
// ./modules/shared/components/markDuplicateModal.js